import { render, staticRenderFns } from "./ArticleTag.vue?vue&type=template&id=9d2bd458&scoped=true"
import script from "./ArticleTag.vue?vue&type=script&lang=js"
export * from "./ArticleTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2bd458",
  null
  
)

export default component.exports